<template lang="pug">
.v-field-code.field-code
	.field-code__list
		.field-code__el(v-if="codeData.lengthCode" )
			input.field-code__input(v-for="(item, index) in codeData.lengthCode"
					type="text"
					v-imask="mask"
					v-model="code[index]"
					:ref="setItemRef"
					@input="onInput(index)"
					maxlength="1"
					@focus="focusStep = index"
					@onblur="focusStep = 0"
					:class="{'error': codeData.error}"
					:disabled="codeData.blocked")
		.field-code__footer
			.field-code__error.c-red-shade-2(v-if="codeData.error") {{codeData.error}}
			.field-code__timer(v-if="localTimer && !codeData.error") {{codeData.timerText}} {{localTimer}}
			button.field-code__action.link-blue.c-primary-shade-2(
					v-if="!localTimer && !codeData.error"
					type="button"
					@click="requestCode") {{codeData.endTimerText}}
			.field-code__message(v-if="codeData.blockedMessage" v-html="codeData.blockedMessage")
</template>

<script>
	export default  {
		props: {
			codeData: {
				type: Object,
				default: {

				},
				required: true
			},
			timer: {
				type: Number,
				required: true
			}
		},
		data() {
			return {
				mask: {
					mask: Number,
					maxLength: 1,
					max: 9,
					lazy: true
				},
				lengthCode: 4,
				itemRefs: [],
				code: [],
				localCodeString: null,
				focusStep: null,
				localTimer: this.timer,
				instanseTimerId: null,
			}
		},

		watch: {
			codeData() {
				this.localTimer = this.timer;
				this.$nextTick().then(() => this.startTimer());
			}
		},
		methods:{
			onAccept (e) {
				const maskRef = e.detail;
				this.value = maskRef.value;
			},

			setItemRef(el) {
				if (el) {
					this.itemRefs.push(el)
				}
			},

			requestCode() {
				this.$emit('requestCode');
			},

			onInput(index) {
				console.log('field-code')
				let step = index;
				this.localCodeString = this.code.join('');
				if (this.localCodeString.length === this.codeData.lengthCode) {
					this.$emit('update:model-value', this.localCodeString);
					return false;
				}
				if (step === this.codeData.lengthCode) {
					this.itemRefs[step].focus();
					return;
				}
				if (this.code[step] !== '') {
					this.itemRefs[++step].focus();
				}
			},
			startTimer() {
				//console.log('startTimer')
				// clearInterval(this.instanseTimerId);
				if (!this.timer) return;
				this.$nextTick().then(() => {
					this.localTimer = this.timer;
					this.instanseTimerId = setInterval(() => {
						if (this.localTimer === 0) {
							this.localTimer = null;
							return;
						}
						this.localTimer--;
						if (this.localTimer === 0) {
							clearInterval(this.instanseTimerId)
						}
					}, 1000)
				})
			},

			handleKeyDown(e) {
				let {key} = e;
				switch (key) {
					case 'ArrowRight' :
						if(this.focusStep < this.itemRefs?.length - 1) {
							this.focusStep++;
							this.itemRefs[this.focusStep].focus()
						}
					break;
					case 'ArrowLeft' :
						if(this.focusStep > 0) {
							this.focusStep--;
							this.itemRefs[this.focusStep].focus()
						}
					break;
					case 'Backspace' :
						if(this.focusStep > 0) {

							if (e.target.value !== '') {
								return;
							}

							this.focusStep--;
							this.itemRefs[this.focusStep].focus()
						}
						break;
				}


			}
		},
		computed: {
			computedTimer() {
				this.localTimer = this.timer;
				return this.localTimer;
			}
		},
		// updated() {
		// 	console.log('updated')
		// },
		beforeUpdate() {
			this.itemRefs = []
		},
		created() {
			document.addEventListener('keydown', this.handleKeyDown)
			this.$nextTick().then(() => this.startTimer());
		},
	}
</script>